import template from './template.headerbar.html'
import controller from './revisions.headerbar.controller'

export default {
  restrict: 'E',
  replace: true,
  template,
  bindings: {
    storyObj: '<',
  },
  controller,
  controllerAs: 'vm',
}
